import React from 'react';
import { SettingsViewProps } from './settingsProps';
import { SettingsConfig } from './settingsConfig';

export function createSettingsView(
    config: Pick<SettingsConfig, 'deps' | 'config'>
): React.FC<SettingsViewProps> {
    const {
        deps: { Layout },
        config: { items },
    } = config;
    const UserComponents = items.filter((item) => item.scope === 'user');
    const OrganizationComponents = items.filter((item) => item.scope === 'organization');
    return (props) => {
        return (
            <Layout.Wrapper>
                <Layout.Container>
                    <Layout.Navigation.List>
                        <Layout.Navigation.Section label="User">
                            {UserComponents.map((item) => (
                                <Layout.Navigation.Item
                                    key={item.key}
                                    to={item.path}
                                    visible={props.isVisible(item)}
                                >
                                    {item.title}
                                </Layout.Navigation.Item>
                            ))}
                        </Layout.Navigation.Section>
                        <Layout.Navigation.Section label="Account">
                            {OrganizationComponents.map((item) => (
                                <Layout.Navigation.Item
                                    key={item.key}
                                    to={item.path}
                                    visible={props.isVisible(item)}
                                >
                                    {item.title}
                                </Layout.Navigation.Item>
                            ))}
                        </Layout.Navigation.Section>
                    </Layout.Navigation.List>
                    <Layout.Body>
                        <>{props.children}</>
                    </Layout.Body>
                </Layout.Container>
            </Layout.Wrapper>
        );
    };
}
